import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import { resolveSwatchUrl } from '../../utils/imageUrl';

const DuplicateNHKStyleModal = ({ show, close, onCreateNew, onAddColor, existingItems, styleName, colorName }) => {

    return (
        <Modal show={show} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>Style Already Exists in New Hire Kit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    The style <strong>{styleName}</strong> already exists in this New Hire Kit with the following color(s):
                </p>
                <ul>
                    {existingItems && existingItems.map((item, idx) => (
                        <li key={idx}>
                            {item.squareImageName && (
                                <img
                                    src={resolveSwatchUrl(item.squareImageName)}
                                    alt={item.colorName}
                                    style={{ width: 20, height: 20, marginRight: 8, verticalAlign: 'middle' }}
                                />
                            )}
                            {item.colorName}
                        </li>
                    ))}
                </ul>
                <p>
                    You are trying to add color: <strong>{colorName}</strong>
                </p>
                <p>
                    Would you like to:
                </p>
                <ul>
                    <li><strong>Add Color</strong> - Add this color as another option for the same item (user can choose one color)</li>
                    <li><strong>Create New Entry</strong> - Create a separate entry (user must select a size for each entry)</li>
                </ul>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={close}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onAddColor}>
                    Add Color
                </Button>
                <Button variant="success" onClick={onCreateNew}>
                    Create New Entry
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DuplicateNHKStyleModal;

